import { UserBuilder } from '../common/users/user-builder';
import { Channel } from './channel.enum';
var UGCItemBuilder = /** @class */ (function () {
    function UGCItemBuilder() {
        this.item = {
            // tslint:disable-next-line:max-line-length
            content: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            user: new UserBuilder().build(),
            creationDate: Date.now() - 100000,
            lastUpdateDate: Date.now(),
            lastOpenedDate: Date.now(),
            channel: Channel.WEB
        };
    }
    UGCItemBuilder.prototype.withContent = function (content) {
        this.item.content = content;
        return this;
    };
    UGCItemBuilder.prototype.withUser = function (user) {
        this.item.user = user;
        return this;
    };
    UGCItemBuilder.prototype.withCreationDate = function (creationDate) {
        this.item.creationDate = creationDate;
        return this;
    };
    UGCItemBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.item.lastUpdateDate = lastUpdateDate;
        return this;
    };
    UGCItemBuilder.prototype.withLastOpenedDate = function (lastOpenedDate) {
        this.item.lastUpdateDate = lastOpenedDate;
        return this;
    };
    UGCItemBuilder.prototype.withChannel = function (channel) {
        this.item.channel = channel;
        return this;
    };
    UGCItemBuilder.prototype.build = function () {
        return this.item;
    };
    return UGCItemBuilder;
}());
export { UGCItemBuilder };
//# sourceMappingURL=ugc-item.builder.js.map